<template>
  <div>
    <div class="container-fluid container-froDesk">
        <div class="wrapper">
            <div class="content-page content-froDesk">
                <div class="content">
                    <div class="row">
                        <!-- 详情 -->
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="dropdown float-right">
                                        <ol class="breadcrumb m-0 p-0">
                                            <li class="breadcrumb-item"><a href="javascript: void(0);">首页</a></li>
                                            <li class="breadcrumb-item"><a href="javascript: void(0);">科研成果</a></li>
                                            <li class="breadcrumb-item"><a href="javascript: void(0);">科研论文</a></li>
                                            <li class="breadcrumb-item active">详情</li>
                                        </ol>
                                    </div>
                                    <h3 class="header-title froDeskHeader-tit mb-3 pb-2">
                                        <span class="tit">详情</span>
                                        <span class="ml-1">Details</span>
                                    </h3>

                                    <div class="General-details pb-3">
                                        <h3 class="genDet-tit text-center mb-4 pt-3">黄埔区11项课题立项为2021年度上海市教育科学研究一般项目</h3>
                                        <div class="genDet-att text-muted text-center mb-4 pb-2">
                                            <span class="p-2">天宁区教育局</span>
                                            <span class="p-2">杨宇，黄芳，王佳欣，王权</span>
                                        </div>
                                        <div class="genDet-con">
                                            <ul class="paperCon-lists row">
                                                <li class="col-md-12">
                                                    <label>类别：</label>
                                                    <div class="con">体育、音乐、美术、劳技、现代信息技术在教学中的应用及其它</div>
                                                </li>
                                                <li class="col-md-3">
                                                    <label>学段：</label>
                                                    <div class="con">小学</div>
                                                </li>
                                                <li class="col-md-3">
                                                    <label>学科：</label>
                                                    <div class="con">美术</div>
                                                </li>
                                                <li class="col-md-6">
                                                    <label>关键词：</label>
                                                    <div class="con">小学，美术，课堂教学</div>
                                                </li>
                                                <li class="col-md-12">
                                                    <label>摘要/简介：</label>
                                                    <div class="con">朱萍对学校将特色校本课程与劳动教育相结合的思路给予肯定，并提出期望：一是希望学校坚持依托集团资源，形成新的共享模式。二是希望学校在黄埔小学教育集团的项目化学习课题引领下，通过助力青年教师的发展，形成学习共同体，带动学校新一轮的发展。朱萍对学校将特色校本课程与劳动教育相结合的思路给予肯定，并提出期望：一是希望学校坚持依托集团资源，形成新的共享模式。二是希望学校在黄埔小学教育集团的项目化学习课题引领下，通过助力青年教师的发展，形成学习共同体，带动学校新一轮的发展。朱萍对学校将特色校本课程与劳动教育相结合的思路给予肯定，并提出期望：一是希望学校坚持依托集团资源，形成新的共享模式。二是希望学校在黄埔小学教育集团的项目化学习课题引领下，通过助力青年教师的发展，形成学习共同体，带动学校新一轮的发展。朱萍对学校将特色校本课程与劳动教育相结合的思路给予肯定，并提出期望：一是希望学校坚持依托集团资源，形成新的共享模式。二是希望学校在黄埔小学教育集团的项目化学习课题引领下，通过助力青年教师的发展，形成学习共同体，带动学校新一轮的发展。朱萍对学校将特色校本课程与劳动教育相结合的思路给予肯定，并提出期望：一是希望学校坚持依托集团资源，形成新的共享模式。二是希望学校在黄埔小学教育集团的项目化学习课题引领下，通过助力青年教师的发展，形成学习共同体，带动学校新一轮的发展。</div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    
                                    <div class="row genDet-page pt-3">
                                        <div class="col-6">
                                            <h4 class="text-muted"><i class="mdi mdi-arrow-left-thick mr-2"></i>上一篇</h4>
                                            <p><a href="">上一篇文章名称</a></p>
                                        </div>
                                        <div class="col-6 text-right">
                                            <h4 class="text-muted">下一篇<i class="mdi mdi-arrow-right-thick ml-2"></i></h4>
                                            <p><a href="">上一篇文章名称</a></p>
                                        </div>
                                    </div>
                                </div> <!-- end card-body-->
                            </div> <!-- end card-->
                        </div>
                        <!-- end 详情-->
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "resultsDetails",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
</style>